import React from 'react'

import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'

export const renderLoader = () => <DefaultLoader />
